let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("7zMjZ"), load("a1dBM"), load("kdCG7")]).then(() => parcelRequire('9yvvI'));